import { useContext, useState } from "react"
import OneModal from "../OneModal/OneModal"
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"

const VideoApresentacao = ({ open, setOpen, idUser }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [loading] = useState(false)

    const [checked, setChecked] = useState(false)

    const getChange = (msg) => {
        if (msg.data.status) {
            let user = JSON.parse(sessionStorage.getItem("o_mo_user"))
            user.onboardingOk = !checked
            sessionStorage.setItem("o_mo_user", JSON.stringify(user))
        }
    }

    const handleChecked = () => {
        addRoute("editarUsuarioConfig", getChange)
        sendWs("editarUsuarioConfig", { usuario: { id: idUser, onboardingOk: !checked } })
        setChecked(!checked)
    }

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            loading={loading}
            titleText="Bem vindo!"
        >
            <div>
                <iframe
                    src="https://player.vimeo.com/video/816389884?h=d8247facc5&autoplay=1&loop=1&title=0&byline=0&portrait=0"
                    width="700px"
                    height="400px"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen
                ></iframe>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {checked
                    ? <CheckBox
                        sx={{ cursor: 'pointer', color: '#8A05BE' }}
                        onClick={handleChecked}
                    />
                    : <CheckBoxOutlineBlank
                        sx={{ cursor: 'pointer', color: '#8A05BE' }}
                        onClick={handleChecked}
                    />}
                <span>Não visualizar novamente</span>
            </div>
        </OneModal>
    )
}

export default VideoApresentacao
